<template>
  <div style="margin: 15px">
    <div class="attendanceDiv">
      <p class="attendanceTitle">考勤组名称</p>
      <el-input
          v-model="groupName"
          style="width: 240px"
          disabled
          placeholder="Please input"
      />
    </div>
    <div class="attendanceDiv">
      <p lass="attendanceTitle">考勤人员</p>
      <p class="attendanceContent">参与考勤人员: {{ attendanceEmployee }}</p>
      <p class="attendanceContent">无需考勤人员:{{ noAttendanceEmployee }}</p>
    </div>

    <div class="attendanceDiv">
      <p lass="attendanceTitle">考勤组负责人</p>
      <p class="attendanceContent">主负责人： {{ attendanceEmployee }}</p>
      <p class="attendanceContent">子负责人：{{ noAttendanceEmployee }}</p>
      <p class="attendanceContent">子负责人权限：{{ noAttendanceEmployee }}</p>
    </div>

    <div class="attendanceDiv">
      <p lass="attendanceTitle">考勤时间</p>
      <p class="attendanceContent">考勤类型： {{ attendanceEmployee }}</p>
      <p class="attendanceContent">工作日设置：{{ noAttendanceEmployee }}</p>
      <p class="attendanceContent">子负责人权限：{{ noAttendanceEmployee }}</p>
    </div>

    <div class="attendanceDiv">
      <p lass="attendanceTitle">打卡方式</p>
      <p class="attendanceContent">考勤方式： {{ attendanceEmployee }}</p>
      <p class="attendanceContent">地点：{{ noAttendanceEmployee }}</p>
      <p class="attendanceContent">子负责人权限：{{ noAttendanceEmployee }}</p>
    </div>

    <div class="attendanceDiv">
      <p lass="attendanceTitle">加班规则</p>
      <p class="attendanceContent">规则名称： {{ attendanceEmployee }}</p>
      <p class="attendanceContent">工作日：{{ noAttendanceEmployee }}</p>
      <p class="attendanceContent">休息日：{{ noAttendanceEmployee }}</p>
    </div>

    <div class="attendanceDiv">
      <p lass="attendanceTitle">外勤规则</p>
      <p class="attendanceContent">规则名称： {{ attendanceEmployee }}</p>
      <p class="attendanceContent">工作日：{{ noAttendanceEmployee }}</p>
      <p class="attendanceContent">休息日：{{ noAttendanceEmployee }}</p>
    </div>

    <div class="attendanceDiv">
      <p lass="attendanceTitle">休息日打卡规则</p>
      <p class="attendanceContent">规则名称： {{ attendanceEmployee }}</p>
      <p class="attendanceContent">工作日：{{ noAttendanceEmployee }}</p>
      <p class="attendanceContent">休息日：{{ noAttendanceEmployee }}</p>
    </div>

    <div class="attendanceDiv">
      <p lass="attendanceTitle">补卡规则</p>
      <p class="attendanceContent">规则名称： {{ attendanceEmployee }}</p>
      <p class="attendanceContent">工作日：{{ noAttendanceEmployee }}</p>
      <p class="attendanceContent">休息日：{{ noAttendanceEmployee }}</p>
    </div>

    <div class="attendanceDiv">
      <p lass="attendanceTitle">拍照验证规则</p>
      <p class="attendanceContent">规则名称： {{ attendanceEmployee }}</p>
      <p class="attendanceContent">工作日：{{ noAttendanceEmployee }}</p>
      <p class="attendanceContent">休息日：{{ noAttendanceEmployee }}</p>
    </div>
  </div>


</template>

<script>

export default {
  name: "AttendanceGroup",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      groupName: 'aa',
      attendanceEmployee: '张三,李四,王五',
      noAttendanceEmployee: '销售部,人事部'
    };
  },
  methods: {

  },
  computed: {

  },

  mounted() {

  }


}
</script>


<style lang="less" scoped>
@import 'src/global';

.attendanceTitle {
  margin: 10px 0px;
}

.attendanceContent {
  color: #888;
}

.attendanceDiv {
  margin-bottom: 10px;
}

</style>
